import React from 'react';

interface IVignetteAutProps {
	className?: string;
	size?: string;
	iconAsBadge?: boolean;
}

export const VignetteAUT = ({ className, iconAsBadge = false, size = '72' }: IVignetteAutProps) => {
	return iconAsBadge ? (
		<svg width="29" height="28" viewBox="0 0 29 28" fill="none" className={className}>
			<path
				d="M20.0373 4L26.3973 24H0.500004C0.497882 25.0688 1.40791 26 2.60259 26H26.3973C27.807 26 28.8169 24.7049 28.4085 23.4206L22.0485 3.42062C21.7802 2.577 20.9633 2 20.0373 2H8.65546C7.71895 2 6.89548 2.58987 6.63626 3.4464L6.46872 4L20.0373 4Z"
				fill="#E2001A"
			/>
			<path d="M8.09949 5.83703L6.08605 5.26441L5.11022 8.48878L7.12366 9.0614L8.09949 5.83703Z" fill="#E2001A" />
			<path
				d="M6.14782 12.2858L4.13439 11.7131L3.15855 14.9375L5.17199 15.5101L6.14782 12.2858Z"
				fill="#E2001A"
			/>
			<path
				d="M4.19616 18.7345L2.18272 18.1619L1.20689 21.3863L3.22032 21.9589L4.19616 18.7345Z"
				fill="#E2001A"
			/>
		</svg>
	) : (
		<svg width={size} height={size} className={className} viewBox="0 0 72 72" fill="none">
			<rect width="72" height="72" fill="#F4F4F4" />
			<rect
				x="11.25"
				y="11.25"
				width="49.5"
				height="49.5"
				rx="5.25"
				fill="white"
				stroke="#707070"
				strokeWidth="1.5"
			/>
			<rect x="14.25" y="14.25" width="43.5" height="43.5" rx="2.25" fill="#F4F4F4" />
			<path d="M3 60.75H64.5" stroke="#707070" strokeWidth="1.5" />
			<path d="M66.75 60.75L69 60.75" stroke="#707070" strokeWidth="1.5" />
			<path
				d="M29.1651 24.9055C29.2577 24.5845 29.5516 24.3634 29.8857 24.3634H41.7613C42.0917 24.3634 42.3832 24.5796 42.479 24.8959L49.078 46.669C49.224 47.1507 48.8636 47.6366 48.3603 47.6366H23.6054C23.1064 47.6366 22.7465 47.1582 22.8848 46.6787L23.6325 44.0867L27.9308 29.1849L29.1651 24.9055Z"
				stroke="#E2001A"
				strokeWidth="2.5"
				strokeLinejoin="round"
			/>
			<path d="M28.8908 25.1926L22.6929 45.9068" stroke="#F4F4F4" strokeWidth="2" strokeDasharray="3 3" />
		</svg>
	);
};
